import { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from './use-toast';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useUserManagement = () => {
  const { token } = useAuth();
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  const apiCall = useCallback(async (method, endpoint, data = null, config = {}) => {
    try {
      const baseConfig = {
        headers: { Authorization: `Bearer ${token}`, ...config.headers }
      };
      
      let response;
      if (method === 'get') {
        response = await axios.get(`${API_URL}${endpoint}`, { ...baseConfig, ...config });
      } else if (method === 'post') {
        response = await axios.post(`${API_URL}${endpoint}`, data, baseConfig);
      } else if (method === 'put') {
        response = await axios.put(`${API_URL}${endpoint}`, data, baseConfig);
      } else if (method === 'patch') {
        response = await axios.patch(`${API_URL}${endpoint}`, data, baseConfig);
      } else if (method === 'delete') {
        response = await axios.delete(`${API_URL}${endpoint}`, baseConfig);
      }
      
      return response.data;
    } catch (error) {
      console.error(`API Error (${method} ${endpoint}):`, error);
      throw error;
    }
  }, [token]);

  const showSuccess = useCallback((title, description) => {
    toast({ title, description });
  }, [toast]);

  const showError = useCallback((title, description) => {
    toast({ variant: 'destructive', title, description });
  }, [toast]);

  const getRoleBadgeColor = useCallback((role) => {
    const colors = {
      admin: 'bg-red-500',
      artist: 'bg-purple-500',
      moderator: 'bg-blue-500',
      user: 'bg-gray-500'
    };
    return colors[role] || 'bg-gray-500';
  }, []);

  return {
    token,
    loading,
    setLoading,
    apiCall,
    showSuccess,
    showError,
    getRoleBadgeColor
  };
};

export default useUserManagement;
